<template>
    <div :id="this.name">
        <div class="ui form equal width left aligned padded grid stackable">
            <div class="sixteen wide tablet two wide computer column">
                <div class="ui vertical secondary pointing fluid tabular menu">
                    <a class="item active" data-tab="settings" @click="component">
                        Impostazioni
                    </a>
                    <a class="item" data-tab="security" @click="component">
                        Sicurezza
                    </a>
                </div>
            </div>
            <div class="sixteen wide tablet fourteen wide computer column">
                <component v-bind:is="tab"/>
            </div>
            
        </div>
    </div>
</template>
<script type="text/javascript">

import { mapState } from 'vuex'

import Component from '../core/Component'

import Settings from './Settings'
import Security from './Security'

export default{

    mixins: [Component],

    components: {
        Settings,
        Security,
    },

    data: () => {
        return {
            name: 'profile',
            tab: 'settings',
        }
    },

    computed: {
        ...mapState('app', ['user']),
    },

    methods: {
        component(event) {
            this.tab = $(event.target).data('tab')
            $('#profile .tabular.menu .item').removeClass('active')
            $(event.target).addClass('active')
        },
        
    },

}
</script>